import {getBillingApi} from "api";

export const fetchPlans = () => ({
    types: ['FETCH_PLANS_REQUEST', 'FETCH_PLANS_SUCCESS', 'FETCH_PLANS_FAILURE'],
    callAPI: () => getBillingApi().listPlans()
});

export const fetchOrder = (orderId) => ({
    types: ['GET_ORDER_REQUEST', 'GET_ORDER_SUCCESS', 'GET_ORDER_FAILURE'],
    callAPI: () => getBillingApi().getOrder({orderId: orderId})
});

export const fetchPaymentGateways = (orderId) => ({
    types: ['FETCH_PAYMENT_GATEWAYS_REQUEST', 'FETCH_PAYMENT_GATEWAYS_SUCCESS', 'FETCH_PAYMENT_GATEWAYS_FAILURE'],
    callAPI: () => getBillingApi().listPaymentGateways({orderId: orderId})
});

export const fetchDiscounts = () => ({
    types: ['FETCH_DISCOUNTS_REQUEST', 'FETCH_DISCOUNTS_SUCCESS', 'FETCH_DISCOUNTS_FAILURE'],
    callAPI: () => getBillingApi().fetchActivatedDiscountCodes()
});

export const fetchPaidOrders = (page, size) => ({
    types: ['FETCH_PAID_ORDERS_REQUEST', 'FETCH_PAID_ORDERS_SUCCESS', 'FETCH_PAID_ORDERS_FAILURE'],
    callAPI: () => getBillingApi().getPaidOrders({page: page, size: size})
});
